export enum DATA_TYPE {
  String = 'String',
  Boolean = 'Boolean',
  Number = 'Number',
  Money = 'Money',
  Date = 'Date',
  Timestamp = 'Timestamp'
};

export const BOOLEAN_VALUE = {
  False: 'FALSE',
  True: 'TRUE'
} as const;

export const LUXON_CELL_FORMAT = {
  Date: 'yyyy-MM-dd',
  DateTime: 'yyyy-MM-dd HH:mm:ss.u'
} as const;

export const EXCEL_CELL_FORMAT = {
  Text: '@',
  Money: '$#,##0.00',
  Date: 'dd/mm/yyyy',
  Timestamp: 'dd/mm/yyyy h:mm:ss AM/PM'
} as const;

export const EXCEL_CELL_TYPE = {
  String: 's',
  Boolean: 'b',
  Number: 'n',
  Date: 'd'
} as const;
